import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { MessageDisplayMethodInfo } from '../../../external/MessageDisplayMethodListApi';
import { MessageInfo } from '../../../external/MessageListApi';
import { actions } from '../../modules/Actions';
import { MasterInfoState } from '../MasterInfoReducer';
import { ErrorDetail, getErrorDetail } from './functions';

export interface SorryMessageState {
  caption: string;
  explanation: string;
  errorDetail?: ErrorDetail;
  messageMstList?: Array<MessageInfo>;
  messageDisplayMethodList?: Array<MessageDisplayMethodInfo>;
}

export interface ErrorParameter {
  functionId: string;
  apiState: string;
  result: Result;
}

export const SORRY_MESSAGE_TYPE = {
  NO_ERROR: {
    caption: '',
    explanation: '',
  },
  FROM_GINIE: {
    caption: 'GINIEからやり直してください',
    explanation: 'ご不便をおかけし申し訳ございません',
  },
  MAINTENANCE: {
    caption: 'メンテナンス中',
    explanation: 'ただいまメンテナンス中です。しばらく経ってからやり直してください。',
  },
  SYSTEM_ERROR: {
    caption: 'システムエラー',
    explanation: 'システムエラーが発生しました。しばらく経ってからやり直してください。',
  },
  LOGIN_FAILED: {
    caption: 'ログイン失敗',
    explanation: 'ログインに失敗しました。しばらく経ってからやり直してください。',
  },
  PERMIT_LOGIN: {
    caption: 'ログイン権限がありません',
    explanation: 'アクセス権限のないユーザでログインしました。',
  },
  LOGIN_TRANSITION: {
    caption: 'ログイン画面遷移',
    explanation: 'ログイン画面に遷移中です。',
  },
  AUTH0_LOGIN_TIMEOUT: {
    caption: 'Auth0ログインタイムアウト',
    explanation:
      'ワンタイムパスワード入力画面表示から一定時間が経過したため、ログインタイムアウトになりました。初めからログインし直してください。',
  },
  AUTH0_LOGIN_FAILED: {
    caption: 'Auth0認証失敗',
    explanation: 'Auth0認証で失敗しました。しばらく経ってからやり直してください。',
  },
  LOGOUT: {
    caption: 'ログアウトしました',
    explanation: 'タブを閉じてください',
  },
  BAD_ACCESS: {
    caption: '不正なアクセスを検知しました',
    explanation: 'タブを閉じてください',
  },
};

const initialSorryMessage: SorryMessageState = SORRY_MESSAGE_TYPE.NO_ERROR;

export const SorryMessageReducer = reducerWithInitialState<SorryMessageState>(initialSorryMessage)
  .case(actions.updateSorryMessage, (state: SorryMessageState, payload: SorryMessageState) => {
    return payload;
  })
  .case(actions.updateErrMessage.errorDetail, (state: SorryMessageState, payload: ErrorParameter) => {
    state.errorDetail = getErrorDetail(state, payload);
    return {
      ...state,
    };
  })
  .case(actions.fetchMasterInfo, (state: SorryMessageState, payload: MasterInfoState) => {
    return {
      ...state,
      messageMstList: payload.messageList,
      messageDisplayMethodList: payload.messageDisplayMethodList,
    };
  });
